module.exports = __webpack_public_path__ + "img/construccion-segura.8f5f028f.png";